@if (!(['xs', 'sm', 'md'] | breakpoint | async)) {
<mat-menu [xPosition]="alignment() === 'left' ? 'before' : 'after'">
  @for (item of items(); track item) { @if (item.items.length) {
  <cec-menu-item
    [items]="item.items"
    [rootItem]="item"
    (onReturnTrigger)="onTrigger($event, item.id)"
    (onItemClicked)="onClickSubItem($event)"
  >
  </cec-menu-item>
  } @if (item.divided) {
  <mat-divider></mat-divider>
  }
  <button
    mat-menu-item
    [class.left-trigger]="item.items?.length && alignment() === 'left'"
    [matMenuTriggerFor]="item.items.length ? obtainedMenus[item.id] : undefined"
    (click)="onClickItem(item, rootItem() ?? item)"
    [disabled]="item.disabled"
  >
    <mat-icon> {{ item.icon }} </mat-icon>
    <span>{{ item.labelKey | translate }} {{ item.subtitle ? (item.subtitle | translate) : "" }}</span>
  </button>
  }
</mat-menu>
} @else { @for (item of items(); track item) { @if (item?.items?.length) {
<mat-expansion-panel [class.mat-elevation-z0]="true" [disabled]="item.disabled">
  <mat-expansion-panel-header>
    <div class="list-item">
      <mat-icon>{{ item.icon }}</mat-icon>
      {{ item.labelKey | translate }}
    </div>
  </mat-expansion-panel-header>
  <cec-menu-item
    [items]="item.items"
    [rootItem]="item"
    (onItemClicked)="onClickSubItem($event)"
  >
  </cec-menu-item>
</mat-expansion-panel>
} @else if (rootItem()) {
<a
  mat-list-item
  [disabled]="item.disabled"
  (click)="onClickItem(item, rootItem())"
>
  <div class="list-item normal">
    <mat-icon>{{ item.icon }}</mat-icon>
    {{ item.labelKey | translate }} {{ item.subtitle ? (item.subtitle | translate) : "" }}
  </div>
</a>
} } }
